const initialState = {
	payment: {
    visible: false,
    tab: null,
  },
	approachMail: {
		visible: false,
	},
	app: {
		visible: false,
	},
	proofPerson: {
		visible: false,
	},
};

export default function reducer(state = initialState, action) {

  if (action.type === 'GUIDE_PAYMENT_SET') {
		let newState = Object.assign({}, state);
		newState.payment.visible = action.payload.visible;
    newState.payment.tab = action.payload.tab;
		return newState;
	}
	else if (action.type === 'GUIDE_APPROACH_MAIL_SET') {
		let newState = Object.assign({}, state);
		newState.approachMail.visible = action.payload.visible;
		return newState;
	}
	else if (action.type === 'GUIDE_APP_SET') {
		let newState = Object.assign({}, state);
		newState.app.visible = action.payload.visible;
		return newState;
	}
	else if (action.type === 'GUIDE_PROOF_PERSON_SET') {
		let newState = Object.assign({}, state);
		newState.proofPerson.visible = action.payload.visible;
		return newState;
	}
	else {
		return state;
	}
}
